import React, { useState } from 'react'

import {
    Row,
    Col,
    Image
} from 'antd'

const MapaLotesLosRiscos = ({textos, mapa, enlace, english}) => {
    const redireccionSelect = e => {
        //window.location = '/macrolote'
        window.location = english ? `/lots-los-riscos/${e.target.value}` : `/lotes-los-riscos/${e.target.value}`
    }

    return (
        <Row align="middle" style={{paddingTop: 10, paddingBottom: 25}}>
            <Col xs={24} md={12}>
                <Image width="100%" src={mapa} />
            </Col>
            <Col xs={24} md={12} className="contenedor-bloques">
                <Row >
                    {textos.map((texto, index) => (
                        <p key={index} className="texto-proyecto">
                            {texto}
                        </p>
                    ))}
                </Row>
                <Row>
                    <select 
                        className="select-plano-maestro"
                        onChange={redireccionSelect}    
                    >
                        <option value="">{english ? 'Select the lot' : 'seleccionar ficha técnica del lote'}</option>
                        <option value="4">{english ? 'Lot' :'Lote'} 4</option>
                        <option value="17">{english ? 'Lot' :'Lote'} 17</option>
                        <option value="18">{english ? 'Lot' :'Lote'} 18</option>
                        <option value="20">{english ? 'Lot' :'Lote'} 20</option>
                        <option value="21">{english ? 'Lot' :'Lote'} 21</option>
                        <option value="22">{english ? 'Lot' :'Lote'} 22</option>
                        <option value="25-26">{english ? 'Lot' :'Lote'} 25-26</option>
                        <option value="a">{english ? 'Lot' :'Lote'} a</option>
                        <option value="e-g2">{english ? 'Lot' :'Lote'} e-g2</option>
                        <option value="f-g3">{english ? 'Lot' :'Lote'} f-g3</option>
                        <option value="g1">{english ? 'Lot' :'Lote'} g1</option>
                        <option value="h">{english ? 'Lot' :'Lote'} h</option>
                    </select>
                </Row>
            </Col>
        </Row>
    )
}

export default MapaLotesLosRiscos